export enum SortDirection {
  Ascending = 'ASC',
  Descending = 'DESC',
}

export enum FilterRoute {
  Order = 'Order',
  CustomerOrder = 'CustomerOrder',
  Product = 'Product',
  Pricing = 'Pricing',
  Payment = 'Payment',
  Invoice = 'Invoice',
  CustomerPayment = 'CustomerPayment',
  CustomerInvoice = 'CustomerInvoice',
  Conversation = 'Conversation',
  Ledger = 'Ledger',
  Dispatch = 'Dispatch',
  CustomerDispatch = 'CustomerDispatch',
  Customer = 'Customer',
  Route = 'Route',
  Turnover = 'Turnover',
  SemanticQuery = 'SemanticQuery',
}

export enum SortOptionKey {
  Date = 'By Date',
  OrderAmount = 'By Order Amount',
  OrderSavings = 'By Order Savings',
  Price = 'By Price',
}

export enum ListFilterKey {
  Cfa = 'CFAs',
  OrderTags = 'Order Tags',
  Schemes = 'Schemes',
  PaymentType = 'Payment Type',
  PaymentMode = 'Payment Mode',
  Divisions = 'Divisions',
  ValidationStatus = 'Validation Status',
  Buyer = 'Buyer',
  Distributor = 'Distributor',
  QueryType = 'Query Type',
  TeamMember = 'Team Member',
  ConversationTags = 'Conversation Tags',
  Customers = 'Customers',
}

export enum TreeFilterKeys {
  Routes = 'Routes',
  Segments = 'Segments',
  DynamicSegments = 'Dynamic Segments',
  CustomerLifeCycle = 'Customer Life Cycle',
}

export interface SortOption {
  field: string;
  display: Record<SortDirection, string>;
  isDefault?: SortDirection;
  selected: SortDirection | false;
}

export interface FilterValue {
  id: string;
  label: string;
  selected: boolean;
  isDefault?: boolean;
  isDisable?: boolean;
  emojiId?: string;
}

export type SortOptionsMap = {
  [key: string]: SortOption;
};

export interface ListFilterOption {
  multiSelect: boolean;
  values: FilterValue[];
}

export type ListFiltersMap = {
  [key in ListFilterKey]: ListFilterOption;
};

export interface TreeInputData extends FilterValue {
  data?: TreeInputData[];
}

export interface TreeFilterOption {
  applyParent: boolean;
  value: TreeInputData[];
}

export type TreeFilterMap = {
  [k in TreeFilterKeys]: TreeFilterOption;
};

export interface FiltersPayload {
  sortOptions?: SortOptionsMap;
  listFilter?: Partial<ListFiltersMap>;
  treeFilter?: Partial<TreeFilterMap>;
}

export type RouteFilterState = {
  [key in FilterRoute]?: {
    loading: boolean;
    filters: FiltersPayload;
  };
};

export interface AppliedFilters {
  sortOptions?: {
    field: string;
    direction: SortDirection;
  };
  listFilter?: Partial<Record<ListFilterKey, string[]>>;
  treeFilter?: Partial<Record<TreeFilterKeys, string[]>>;
}

export type AppliedFilterState = {
  [key in FilterRoute]?: AppliedFilters;
};
